import React, { useState, useEffect } from 'react';

import axios from 'axios';

import {
    Route,
    useHistory,
    useRouteMatch,
} from 'react-router-dom';

import { Formik } from 'formik';

import { Button, Form, Row, Col } from 'react-bootstrap';

import {
    Container, CenteredTD, Header, HeaderActions, PrimaryButton, Panel, Toolbar, TableScroll, ListTable,
    FormActions, StyledTR, SideDrawer, Pager, SuccessToast, SearchField,
} from '../ManageLayout';

import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const fetchEntities = async (page = 1, filter = '') => {
    let url = `${process.env.REACT_APP_SERVER}geo-service/manage/micros?page=${page}`;
    if (filter) url = `${url}&filter=${encodeURIComponent(filter)}`;
    return await axios.get(url);
}

function ManageMicro() {
    const [micros, setMicros] = useState(null);
    const [paginatorData, setPaginatorData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [filtering, setFiltering] = useState('');

    const history = useHistory();

    const [assocs, setAssocs] = useState([]);
    useEffect(() => {
        async function fetchAssocs() {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/assocs`);
            setAssocs(data);
        }

        fetchAssocs();
    }, []);

    useEffect(() => {
        async function fetchMicros(page = 1, filter = '') {

            const { data: { rows, pages, hasPrevious, hasNext } } = await fetchEntities(page, filter);

            setMicros(rows);
            setPaginatorData({ pages, hasPrevious, hasNext });
        }

        if (currentPage) fetchMicros(currentPage, filtering);
    }, [currentPage, filtering]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const handleEdit = (id) => {
        history.push(`/microrregioes/gerenciar/${id ? id : ''}`);
    }

    const handleClose = () => {
        history.push('/microrregioes');
    }

    const handleUpdate = () => {
        doToast('Os dados da microrregião foram gravados!');
        handleClose();
        refresh();
    }

    const doToast = (message) => {
        setToastMessage(message);
        setShowToast(true);
    }

    const refresh = () => {
        // TODO: best practices
        const currentPageCopy = currentPage;
        setCurrentPage(null);
        setCurrentPage(currentPageCopy);
    }

    const handleFilter = (filter) => {
        setCurrentPage(1);
        setFiltering(filter);
    }

    return <>
        <List
            currentPage={currentPage}
            micros={micros}
            paginatorData={paginatorData}
            filtering={filtering}
            handlePageChange={handlePageChange}
            handleEdit={handleEdit}
            handleFilter={handleFilter}
            assocs={assocs}
        />

        <Route path="/microrregioes/gerenciar/:id?" render={({ match }) => (
            <Manage
                key={match.params.id || 'new'}
                id={match.params.id}
                assocs={assocs}
                onUpdate={handleUpdate}
                onClose={handleClose}
            />
        )} />

        <SuccessToast show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
    </>;
}

function Manage({ id, assocs, onUpdate, onClose }) {
    const [data, setData] = useState({
        nome: '',
    });

    useEffect(() => {
        async function fetchMicro(id) {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/micros/${id}`);
            setData(data);
        }

        if (id) fetchMicro(id);
    }, [id]);

    return (
        <SideDrawer title={id ? 'Microrregião' : 'Nova microrregião'} onClose={onClose}>
            <ManageMain id={id} data={data} onUpdate={onUpdate} onClose={onClose} assocs={assocs} />
        </SideDrawer>
    );
}

function ManageMain({ id, data, assocs, onUpdate, onClose }) {
    const [saving, setSaving] = useState(false);

    const validate = async values => {
        const errors = {};

        if (!values.nome) {
            errors.nome = 'O NOME deve ser preenchido';
        }

        return errors;
    };

    const save = async (data) => {
        setSaving(true);

        const { data: { savedId } } = await axios.post(`${process.env.REACT_APP_SERVER}geo-service/manage/micros/${id ? id : ''}`, data);

        setSaving(false);

        onUpdate(!id ? savedId : null);
    }

    return (
        <Formik
            validate={validate}
            onSubmit={save}
            enableReinitialize={true}
            initialValues={{
                nome: data.nome ? data.nome : '',
                assoc: data.assoc ? data.assoc.id : -1,
            }}
        >
            {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
            }) => (
                <Form noValidate onSubmit={(e) => { handleSubmit(e); }}>
                    <Row>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Nome*</Form.Label>
                                <Form.Control name="nome" placeholder="Digite o NOME da microrregião" value={values.nome} onChange={handleChange} isValid={touched.nome && !errors.nome} isInvalid={!!errors.nome} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.nome}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Associação / Cooperativa*</Form.Label>
                                <Form.Control as="select" name="assoc" value={values.assoc} onChange={handleChange} isValid={touched.assoc && !errors.assoc} isInvalid={!!errors.assoc} custom>
                                    <option value={-1}> -- Selecione uma Associação / Cooperativa -- </option>
                                    {assocs && assocs.map(({ id, nome }) => <option key={id} value={id}>{nome}</option>)}
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.assoc}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <FormActions>
                        <Button variant="outline-secondary" onClick={onClose}>
                            Cancelar
                        </Button>
                        <PrimaryButton type="submit" disabled={saving}>
                            {saving ? 'Gravando...' : (id ? 'Salvar alterações' : 'Cadastrar microrregião')}
                        </PrimaryButton>
                    </FormActions>
                </Form>
            )}
        </Formik>
    );
}

function List({ currentPage, assocs, micros, filtering, paginatorData, handleEdit, handleFilter, handlePageChange }) {
    const editing = useRouteMatch('/microrregioes/gerenciar/:id?');
    const selectedId = editing ? editing.params.id : null;

    const [filter, setFilter] = useState(filtering || '');

    const assocName = (assocId) => {
        const assoc = assocs && assocs.find(({ id }) => id === assocId);
        return assoc ? assoc.nome : '-';
    }

    return (<Container>
        <Header>
            <div>
                <h4>Gestão de Microrregiões</h4>
                <small>Microrregiões e a associação / cooperativa a que pertencem</small>
            </div>
            <HeaderActions>
                <PrimaryButton onClick={() => handleEdit()}>
                    <FontAwesomeIcon icon={faPlus} /> Nova microrregião
                </PrimaryButton>
            </HeaderActions>
        </Header>

        <Panel>
            <Toolbar>
                <SearchField
                    icon={faSearch}
                    placeholder="Buscar microrregião pelo nome..."
                    value={filter}
                    onChange={setFilter}
                    onSearch={handleFilter}
                    active={!!filtering}
                />
            </Toolbar>

            <TableScroll>
                <ListTable>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Associação / Cooperativa</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!micros && <tr><CenteredTD colSpan={2}>Carregando...</CenteredTD></tr>}
                        {micros && micros.length === 0 && <tr><CenteredTD colSpan={2}>Nenhuma microrregião encontrada!</CenteredTD></tr>}
                        {micros && micros.map((row) => <StyledTR
                            key={row.id}
                            className={`clickable ${String(row.id) === selectedId ? 'selected' : ''}`}
                            tabIndex={0}
                            onClick={() => handleEdit(row.id)}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleEdit(row.id); }}
                        >
                            <td><span className="name">{row.nome}</span></td>
                            <td>{assocName(row.assocId)}</td>
                        </StyledTR>)}
                    </tbody>
                </ListTable>
            </TableScroll>

            <Pager currentPage={currentPage} paginatorData={paginatorData} onChangePage={handlePageChange} />
        </Panel>
    </Container>);
}

export default ManageMicro;
